import axiosInstance from "../api";
import React, {useState} from "react";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import {toast} from "react-toastify";
import {candidateHooks} from "../api/candidate.api";

interface DownloadResumesProps {
  resumeIds: number[] | string[];
  disabled?: boolean;
}

const DownloadResumes: React.FC<DownloadResumesProps> = ({resumeIds, disabled}) => {
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true)
  };

  const handleDownload = async () => {
    if (!resumeIds.length) {
      toast.warning("Нет резюме для скачивания!");
      return;
    }

    setLoading(true);

    try {
      const response = await axiosInstance.post(
        "/api/candidate/download-multiple",
        { resumeIds, categoryId: selectedCategory },
        {
          responseType: "blob",
          timeout: 240000, // 4 минуты
        }
      );

      const contentDisposition = response.headers["content-disposition"];

      let filename = "resumes.zip";

      if (contentDisposition) {
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/);
        if (utf8Match) {
          filename = decodeURIComponent(utf8Match[1]);
        } else {
          const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
          if (match) {
            filename = match[1];
          }
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename.replaceAll(' ', '_');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      toast.success("Скачивание началось!");
    } catch (error) {
      console.error("Ошибка загрузки:", error);
      toast.error("Ошибка при скачивании резюме");
    } finally {
      setLoading(false);
    }
  };

  const {data: categories} = candidateHooks.useCandidateCategories()
  const getListCategories = () => {
    if (!categories || !categories[0]) return []
    return categories[0]
  }
  const listCategories = getListCategories()

  const handleForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

  }

  return (
    <>
      <Button className="mb-3" onClick={handleShow} disabled={loading}>
        Массово скачать резюме {loading && <Spinner animation="border" size="sm"/>}
      </Button>

      <Modal show={show} size='lg' onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Массово скачать резюме</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!disabled && (
            <div className="mb-4">

              <div className="form-group mb-2 d-flex gap-4 items-center">
                <label>Категория</label>
                <Form.Control
                  as="select"
                  value={selectedCategory || ""}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value)
                  }}
                >
                  <option value="">Выберите категорию</option>
                  {listCategories?.map((category: any) => (
                    <option key={category.id} value={category.id}>
                      {category.name} (Всего: {category?.candidateCount})
                    </option>
                  ))}
                </Form.Control>
              </div>
              <Form.Text className="text-muted text-sm text-gray-500">
                Выберите подходящую категорию из списка чтобы загрузить все резюме пользователей из категории
              </Form.Text>
            </div>
          )}


          <div className="mb-5 mt-3">
            {!selectedCategory && (
              <Form.Text className="text-sm te alert alert-warning">
                Вы загрузите все резюме с текущей страницы
              </Form.Text>
            )}
          </div>

          <Button onClick={handleDownload} disabled={loading}>
            Скачать {loading && <Spinner animation="border" size="sm"/>}
          </Button>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default DownloadResumes;
